import { Action } from '@ngrx/store';
import { WorkOrderDto, MaterialDto, WorkOrderObjectDto } from '@app/generated/model';
import { WorkLineModel, WorkOrderObjectModel } from '@app/work-order/objects/work-order-object.model';

export enum WorkOrderActionTypes {
  LoadWorkOrder = 'LoadWorkOrder',
  LoadWorkOrderSuccess = 'LoadWorkOrderSuccess',
  LoadWorkOrderMaterials = 'LoadWorkOrderMaterials',
  LoadWorkOrderObjects = 'LoadWorkOrderObjects',
  LoadWorkOrderObjectsSuccess = 'LoadWorkOrderObjectsSuccess',
  LoadWorkOrderDocuments = 'LoadWorkOrderDocuments',
  UpdateWorkLineProgress = 'UpdateWorkLineProgress',
  UpdateWorkLineProgressSuccess = 'UpdateWorkLineProgressSuccess',
  LoadWorkOrderDocumentsSuccess = 'LoadWorkOrderDocumentsSuccess',
  SelectWorkLine = 'SelectWorkLine',
  DeSelectWorkLine = 'DeSelectWorkLine',
  DeSelectWorkLines = 'DeSelectWorkLines',
  SelectWorkLines = 'SelectWorkLines',
  SelectObject = 'SelectObject',
  DeSelectObject = 'DeSelectObject',
  SelectAllObjects = 'SelectAllObjects',
  DeselectAllObjects = 'DeselectAllObjects',
  UpdateWorkLineQuantity = 'UpdateWorkLineQuantity',
  MarkWorkLineAsComplete = 'MarkWorkLineAsComplete',
  ReOpenWorkLine = 'ReOpenWorkLine',
  UpdateWorkLineCableLength = 'UpdateWorkLineCableLength',
  OpenMarkupDocument = '[PdfMarkup] Open Document',
  ClearMarkupDocument = '[PdfMarkup] Clear Document',
}

export class LoadWorkOrder implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrder;
  constructor(public workOrderId: string) {}
}

export class LoadWorkOrdersSuccess implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderSuccess;

  constructor(public workOrder: WorkOrderDto) {}
}

export class LoadWorkOrderMaterials implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderMaterials;

  constructor(public workOrderId: string) {}
}

export class LoadWorkOrderMaterialsSuccess implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderMaterials;

  constructor(public materials: MaterialDto[]) {}
}

export class LoadWorkOrderObjects implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderObjects;

  constructor(public workOrderId: string) {}
}

export class LoadWorkOrderObjectsSuccess implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderObjectsSuccess;

  constructor(public operations: WorkOrderObjectDto[]) {}
}

export class LoadWorkOrderDocuments implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderDocuments;

  constructor(public workOrderId: string) {}
}

export class LoadWorkOrderDocumentsSuccess implements Action {
  readonly type = WorkOrderActionTypes.LoadWorkOrderDocumentsSuccess;

  constructor(public documents: any[]) {}
}

export class UpdateWorkLineProgress implements Action {
  readonly type = WorkOrderActionTypes.UpdateWorkLineProgress;

  constructor(
    public workLineIds: String[],
    public progress: number,
  ) {}
}

export class UpdateWorkLineQuantity implements Action {
  readonly type = WorkOrderActionTypes.UpdateWorkLineQuantity;
  constructor(
    public workLineId: String,
    public quantity: number,
  ) {}
}

export class UpdateWorkLineCableLength implements Action {
  readonly type = WorkOrderActionTypes.UpdateWorkLineCableLength;
  constructor(
    public workLineId: String,
    public length: number,
    public externalLocationId: number,
  ) {}
}

export class MarkWorkLineAsComplete implements Action {
  readonly type = WorkOrderActionTypes.MarkWorkLineAsComplete;
  constructor(public workLineId: String) {}
}

export class ReOpenWorkLine implements Action {
  readonly type = WorkOrderActionTypes.ReOpenWorkLine;
  constructor(public workLineId: String) {}
}

export class SelectWorkLine implements Action {
  readonly type = WorkOrderActionTypes.SelectWorkLine;

  constructor(public workLine: WorkLineModel) {}
}

export class DeselectWorkLine implements Action {
  readonly type = WorkOrderActionTypes.DeSelectWorkLine;

  constructor(public workLine: WorkLineModel) {}
}

export class SelectWorkLines implements Action {
  readonly type = WorkOrderActionTypes.SelectWorkLines;

  constructor(public workLines: WorkLineModel[]) {}
}

export class DeselectWorkLines implements Action {
  readonly type = WorkOrderActionTypes.DeSelectWorkLines;

  constructor(public workLines: WorkLineModel[]) {}
}

export class SelectObject implements Action {
  readonly type = WorkOrderActionTypes.SelectObject;

  constructor(public object: WorkOrderObjectModel) {}
}

export class DeSelectObject implements Action {
  readonly type = WorkOrderActionTypes.DeSelectObject;

  constructor(public object: WorkOrderObjectModel) {}
}

export class SelectAllObjects implements Action {
  readonly type = WorkOrderActionTypes.SelectAllObjects;

  constructor(public parentObjects: WorkOrderObjectModel[]) {}
}

export class DeselectAllObjects implements Action {
  readonly type = WorkOrderActionTypes.DeselectAllObjects;
}

export class OpenMarkupDocument implements Action {
  readonly type = WorkOrderActionTypes.OpenMarkupDocument;
  constructor(public documentId: string) {}
}

export class ClearMarkupDocument implements Action {
  readonly type = WorkOrderActionTypes.ClearMarkupDocument;
}

export type WorkOrderActions =
  | LoadWorkOrder
  | LoadWorkOrdersSuccess
  | LoadWorkOrderMaterials
  | LoadWorkOrderMaterialsSuccess
  | LoadWorkOrderObjects
  | LoadWorkOrderObjectsSuccess
  | LoadWorkOrderDocuments
  | LoadWorkOrderDocumentsSuccess
  | UpdateWorkLineProgress
  | UpdateWorkLineQuantity
  | UpdateWorkLineCableLength
  | MarkWorkLineAsComplete
  | ReOpenWorkLine
  | SelectWorkLine
  | DeselectWorkLine
  | SelectWorkLines
  | DeselectWorkLines
  | SelectObject
  | DeSelectObject
  | SelectAllObjects
  | DeselectAllObjects
  | OpenMarkupDocument
  | ClearMarkupDocument;
